<script lang="ts">
	import { getTrackingEnvironment } from '$lib/tracking';
</script>

<svelte:head>
	<script
		src="https://tags-eu.tiqcdn.com/utag/telekom/erlebenwasverbindet/{getTrackingEnvironment()}/utag.js"
		defer
	></script>
</svelte:head>
